@let controlLocal = control();
@if (controlLocal && controlLocal.touched && controlLocal.invalid) {
  @if (controlLocal.hasError("required")) {
    <p class="error mb-0">{{ "form.error_required" | translate }}</p>
  } @else if (controlLocal.hasError("pattern")) {
    <p class="error mb-0">{{ "form.error_email" | translate }}</p>
  } @else if (controlLocal.hasError("minlength")) {
    <p class="error mb-0">
      {{ "form.error_min_characters" | translate: valueMinLength() }}
    </p>
  } @else if (controlLocal.hasError("maxlength")) {
    <p class="error mb-0">
      {{ "form.error_max_characters" | translate: valueMaxLength() }}
    </p>
  } @else if (controlLocal.hasError("min")) {
    <p class="error mb-0">
      {{ "form.error_min_value" | translate: valueMin() }}
    </p>
  } @else if (controlLocal.hasError("max")) {
    <p class="error mb-0">
      {{ "form.error_max_value" | translate: valueMax() }}
    </p>
  } @else if (controlLocal.hasError("password")) {
    <p class="error mb-0">
      {{ "recomendacion_user" | translate }}
    </p>
  } @else if (controlLocal.hasError("confirmPassword")) {
    <p class="error mb-0">{{ "components.register_form.password_not_match" | translate }}</p>
  } @else if (controlLocal.hasError("invalidEmail")) {
    <p class="error mb-0">{{ "form.error_invalid_email" | translate }}</p>
  } @else if (controlLocal.hasError("invalidUsername")) {
    <p class="error mb-0">{{ "form.error_username" | translate }}</p>
  }
}
